// extracted by mini-css-extract-plugin
export var askAiIcon = "_kh-9";
export var container = "_kh-0";
export var groupSeparator = "_kh-a";
export var highlight = "_kh-4";
export var resultIcon = "_kh-5";
export var resultItem = "_kh-7";
export var resultSubtitle = "_kh-3";
export var resultTitle = "_kh-2";
export var resultsList = "_kh-1";
export var searchGroup = "_kh-6";
export var selected = "_kh-8";